module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Regular.a91533de.woff";